import { render, staticRenderFns } from "./DigitalSignageTvQRCode.vue?vue&type=template&id=38db0474&scoped=true"
import script from "./DigitalSignageTvQRCode.ts?vue&type=script&lang=ts&external"
export * from "./DigitalSignageTvQRCode.ts?vue&type=script&lang=ts&external"
import style0 from "./DigitalSignageTvQRCode.scss?vue&type=style&index=0&id=38db0474&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db0474",
  null
  
)

export default component.exports